import React from "react";
import { Stack, TextField, FormControlLabel, Switch, MenuItem } from "@mui/material";
import HtmlEditor from "./HtmlEditor";

const QuestionFormVideo = ({ value, onChange }) => {
    const v = value || {};

    return (
        <Stack spacing={2}>
            <TextField
                label="Тип завдання"
                value={"video"}
                fullWidth
                select
                disabled
                helperText="Відеозавдання або творче завдання."
            >
                <MenuItem value="video">Відео</MenuItem>
            </TextField>

            <TextField
                label="Підзаголовок"
                value={v.subtitle || ""}
                onChange={(e) => onChange({ ...v, subtitle: e.target.value })}
                helperText="Необов'язково. Показується під назвою модуля."
                fullWidth
            />

            <TextField
                label="CSS-клас відображення"
                value={v.addClass || ""}
                onChange={(e) => onChange({ ...v, addClass: e.target.value })}
                placeholder="horizontal"
                helperText="Службове поле. Наприклад: horizontal."
                fullWidth
            />

            <TextField
                label="Посилання на відео"
                value={v.videoPath || ""}
                onChange={(e) => onChange({ ...v, videoPath: e.target.value })}
                placeholder="https://www.youtube.com/embed/..."
                helperText="Вставте embed-посилання на відео."
                fullWidth
            />

            <FormControlLabel
                control={
                    <Switch
                        checked={Boolean(v.shouldGoNext)}
                        onChange={(e) => onChange({ ...v, shouldGoNext: e.target.checked })}
                    />
                }
                label="Показувати кнопку переходу далі після відео"
            />

            <FormControlLabel
                control={
                    <Switch
                        checked={Boolean(v.isCreativeTask)}
                        onChange={(e) => onChange({ ...v, isCreativeTask: e.target.checked })}
                    />
                }
                label="Творче завдання"
            />

            <HtmlEditor
                label="Текст завдання (HTML)"
                value={v.question || ""}
                onChange={(question) => onChange({ ...v, question })}
                helperText="Опис або інструкція до відео/творчого завдання."
                minHeight={144}
            />
        </Stack>
    );
};

export default QuestionFormVideo;
